import useSharedStore from '@/presentation/store/shared';
import { useBusinessStore } from '@/presentation/modules/business';
import layoutLoading from '@/presentation/components/common/layout-loading/layoutLoading.js';
import { getCookie } from '@/presentation/libs/cookie.lib';
import { getRoleFromAccessToken } from '@/presentation/router/defaultRoute.router';
import notify from '@/presentation/utils/notify.util';
import {
	BUSINESS_ONBOARDING_ROUTE_NAME,
	BUSINESS_ONBOARDING_ROUTE_PATH,
	LOCKED_BUSINESS_ROUTE_NAMES,
	getBusinessOnboardingFlags,
} from '@/presentation/modules/dashboard/composables/useBusinessOnboardingState';
const shouldLoadBusinessInfo = (to: any) =>
	Boolean(to.meta?.requiresBusinessInfo || to.meta?.requiresAuth || to.path?.startsWith('/dashboard') || to.name === 'Home');

const OPEN_BUSINESS_ROUTE_NAMES = new Set(['Home', 'Explore']);
const ONBOARDING_SETUP_ROUTE_NAMES = new Set([
	'DashboardServices',
	'DashboardArtists',
	'DashboardCreateArtist',
	'DashboardUpdateArtist',
	'DashboardServiceArtistAssignments',
	'ProfileCreatePost',
]);

const loadBusinessInfoMiddleware = (router) => {
	router.beforeEach(async (to) => {
		const sharedStore = useSharedStore();
		const businessStore = useBusinessStore();
		const token = getCookie('access-token');

		if (!token || getRoleFromAccessToken(token) !== 'Business' || !shouldLoadBusinessInfo(to)) return true;

		let businessInfo: Record<string, any> = sharedStore.businessInfo || {};
		if (!businessInfo?.id) {
			layoutLoading.setLoading(true);
			try {
				const response = await businessStore.inquiryBusiness();
				businessInfo = response.data;
				sharedStore.setBusinessInfo(response.data);
			} finally {
				layoutLoading.setLoading(false);
			}
		}

		const flags = getBusinessOnboardingFlags(businessInfo);
		const targetRouteName = String(to.name || '');
		const isOnboardingRoute = targetRouteName === BUSINESS_ONBOARDING_ROUTE_NAME;
		const isOpenBusinessRoute = OPEN_BUSINESS_ROUTE_NAMES.has(targetRouteName) || to.path === '/' || to.path === '/home' || to.path === '/explore';

		if (flags.isFullyActive && isOnboardingRoute) return { name: 'Index' };

		const isOnboardingSetupRoute = ONBOARDING_SETUP_ROUTE_NAMES.has(targetRouteName);
		if (!flags.isProfileComplete && !isOnboardingRoute && !isOpenBusinessRoute && !isOnboardingSetupRoute) return BUSINESS_ONBOARDING_ROUTE_PATH;

		if (!flags.isFullyActive && LOCKED_BUSINESS_ROUTE_NAMES.has(targetRouteName)) {
			notify({
				message: 'این بخش بعد از تایید کسب و کار فعال می شود.',
				type: 'info',
				duration: 5000,
			});
			return BUSINESS_ONBOARDING_ROUTE_PATH;
		}

		return true;
	});
};

export default loadBusinessInfoMiddleware;
